import {
  determineIfRoleIsOP,
  determineIsER,
  determineIsES,
} from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { getBestCounterparty } from "../actionSummaryMainTableColDefs";
import tradeDataStore from "@/store/tradeDataStore";
import { IExecutionRequestCounterParties } from "@/lib/interfaces and Enums/InterfaceExecutionRequestCounterParties";
import { ICustomCellRendererProps } from "@/lib/interfaces and Enums/InterfaceCustomCellRenderer";
import { SecurityTypeCode } from "@/lib/interfaces and Enums/ENUMSecurityTypeCode";

const ProviderCellRenderer = (params: ICustomCellRendererProps) => {
  //   let thisTrade = tradeDataStore((state) => //todo
  //   state.tradeData.find((trade) => trade.esid == params.fullTradeData?.esid),
  // );

  const isES = determineIsES(params);
  const isER = determineIsER(params);
  const isOp = isES
    ? determineIfRoleIsOP(params.data, params.data)
    : determineIfRoleIsOP(params.fullTradeData, params.data);
  const tradeData = tradeDataStore((state) => state.tradeData);
  let thisTrade;
  if (isES) {
    thisTrade =
      tradeData.find((trade) => trade.esid == params.data.esid) ?? params.data;
  } else if (isER) {
    thisTrade =
      tradeData.find((trade) => trade.esid == params.fullTradeData?.esid) ??
      params.fullTradeData;
  }

  let counterpartyToReturn = "";

  if (isES) {
    const bestCounterparty = getBestCounterparty(
      // params.data,
      thisTrade,
      params.colDef?.colId,
    );
    if (!isOp) counterpartyToReturn = params.data.originatingCounterparty;
    else if (isOp && bestCounterparty) {
      if (
        bestCounterparty.deskRestrictions &&
        bestCounterparty.deskRestrictions.length > 0
      ) {
        counterpartyToReturn = `${bestCounterparty.provider} (${bestCounterparty.deskRestrictions.length})`;
      } else counterpartyToReturn = bestCounterparty.provider;
    } else counterpartyToReturn = "";
  }

  if (isER && isOp && params.fullTradeData) {
    //indicate if there are desk restrictions

    let executionRequest: IExecutionRequestCounterParties = {
      executionRequestId: 0,
      order: 0,
      legs: [
        {
          blockId: 0,
          notionalLeg1: 0,
          settlementDate: new Date(),
          notation: "",
          securityType: SecurityTypeCode.ABS,
        },
      ],
    };

    thisTrade?.executionRequestCounterParties?.forEach(
      (ER: IExecutionRequestCounterParties) => {
        if (ER.executionRequestId == params.data.executionRequestId) {
          executionRequest = ER;
        }
      },
    );

    if (executionRequest.executionRequestId == 0) {
      counterpartyToReturn = params.data.provider;
    }
    if (executionRequest && executionRequest.provider) {
      if (
        executionRequest.deskRestrictions &&
        executionRequest.deskRestrictions.length > 0
      ) {
        counterpartyToReturn = `${executionRequest.provider} (${executionRequest.deskRestrictions.length})`;
      } else counterpartyToReturn = executionRequest.provider;
    }
  }

  return <div>{counterpartyToReturn}</div>;
};

export default ProviderCellRenderer;
